import * as React from "react";
const SvgFiRrUxBrowser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m13.143 17.485 1.191-1.985-1.191-1.985a1 1 0 1 1 1.715-1.029l.643 1.071.643-1.071a.999.999 0 1 1 1.715 1.029L16.668 15.5l1.191 1.985a1 1 0 0 1-1.715 1.03l-.643-1.071-.643 1.071a1 1 0 0 1-1.715-1.03M9 19c1.654 0 3-1.346 3-3v-3a1 1 0 0 0-2 0v3a1.001 1.001 0 0 1-2 0v-3a1 1 0 0 0-2 0v3c0 1.654 1.346 3 3 3M4.5 4a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 4.5 4M24 6v12c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V6c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 4H2v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3zm0-4c0-1.654-1.346-3-3-3H5C3.346 3 2 4.346 2 6v2h20zM8.5 4a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 4"
    />
  </svg>
);
export default SvgFiRrUxBrowser;
